import { useAtomValue } from 'jotai';

import { userCountryCodeAtom } from 'src/stores/auth/atoms';

const GDPR_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
];
const useTermsInfo = () => {
  const userCountryCode = useAtomValue(userCountryCodeAtom);

  const isGDPR = !!userCountryCode && GDPR_CODES.includes(userCountryCode);

  return { isGDPR };
};

export default useTermsInfo;
